import clsx from 'clsx';
import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/20/solid';
import getStatusColors from '@dashboard/services/status/getStatusColors';
import Badge from './Badge';
import Tooltip from './Tooltip';
import isDraftStatus from '../services/status/isDraftStatus';

const StatusBadge = ({ status, withInfoIcon, label, className, livemode, ...props }) => {
  const { className: statusClassName } = getStatusColors(status);
  const { className: testClassName } = getStatusColors('test');

  const statusLabel = label || status;

  if (isDraftStatus(status)) {
    return (
      <Tooltip label="No payment method added.">
        <Badge className={clsx(statusClassName, className, 'inline-flex')} {...props}>
          {statusLabel}

          <InformationCircleIcon
            className={clsx('w-4 h-4 ml-1')}
            style={{
              color: statusClassName.textColor,
            }}
          />
        </Badge>
      </Tooltip>
    );
  }

  return (
    <>
      {livemode === false && (
        <Badge className={clsx(testClassName, className, 'inline-flex')} {...props}>
          Test
        </Badge>
      )}

      <Badge className={clsx(statusClassName, className, 'inline-flex')} {...props}>
        {statusLabel}

        {withInfoIcon && (
          <InformationCircleIcon
            className={clsx('w-4 h-4 ml-1')}
            style={{
              color: statusClassName.textColor,
            }}
          />
        )}
      </Badge>
    </>
  );
};

export default StatusBadge;
